<template>
    <div id="freeReportForm">
        <fieldset>
            <div class="flex flex-col lg:flex-row items-center justify-between bg-blue-100/50 border-3 border-blue-200/50 rounded-lg px-6 py-8 mb-4">
                <div class="flex-1 flex flex-col space-y-4 w-full pr-6">
                    <label for="name" class="font-semibold text-lg">Name<sup class="text-red-500">*</sup>
                        <input id="name" v-model="form.name" @input="errors.name = false" :class="{ 'is-invalid': errors.name }" type="text" placeholder="Your Name" class="form-input flex-1" />
                    </label>
                    <label for="email" class="font-semibold text-lg">Email<sup class="text-red-500">*</sup>
                        <input id="email" v-model="form.email" @input="errors.email = false" :class="{ 'is-invalid': errors.email }" type="email" placeholder="Email Address" class="form-input flex-1" />
                    </label>
                    <div class="text-red-600 text-sm !mt-0" v-if="haveErrors()">
                        Please fill in the required fields and try again.
                    </div>
                </div>
                <div class="flex flex-col items-center justify-center space-y-4">
                    <div v-if="!loggedIn" class="w-full flex flex-col items-center -mb-4">
                        <div id="captcha" class="mb-2 mx-auto"></div>
                        <div v-if="errors.captcha" class="text-red-600 text-sm -mt-2 mb-2">The reCAPTCHA was not entered correctly</div>
                    </div>
                    <a :class="{ 'btn-disabled': loading }" @click="submit" type="button" class="bg-blue-600 hover:bg-blue-800 text-white hover:text-white focus:text-white font-bold text-sm px-10 py-6 rounded shadow-lg leading-normal text-center text-lg lg:text-2xl cursor-pointer">
                        CLICK HERE<br />FOR FREE REPORT
                        <!-- CLICK HERE<br />TO CLAIM YOUR<br />FREE SPECIAL<br />REPORT NOW -->
                    </a>
                </div>
            </div>
        </fieldset>

        <flash-message ref="flashRef" :seconds-to-display="10"></flash-message>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';

const props = defineProps({
    siteKey: String,
});
const flashRef = ref(null);
const errors = ref({
    name: false,
    email: false,
    captcha: false
});
const form = ref({
    name: '',
    email: (window.currentUser && window.currentUser.email) || '',
    captcha: ''
});
const loggedIn = ref((window.currentUser && window.currentUser.username) ? true : false);
const displayEmail = ref('');
const loading = ref(false);

const haveErrors = () => {
    return Object.values(errors.value).some(error => error !== false);
};

const validate = () => {
    let valid = true;
    if (loggedIn.value) {
        form.value.captcha = true;
    }

    Object.keys(form.value).forEach((formName) => {
        if (form.value[formName] === '') {
            errors.value[formName] = 'Please fill this field';
            valid = false;
        }
    });

    return valid;
};

const updateCaptcha = (response) => {
    form.value.captcha = response;
};

const reset = () => {
    Object.keys(form.value).forEach((formName) => {
        form.value[formName] = '';
    });

    Object.keys(errors.value).forEach((eName) => {
        errors.value[eName] = false;
    });

    if (!loggedIn.value) {
        grecaptcha.reset();
    }
};

const submit = () => {
    const route = loggedIn.value
        ? window.route('main.freereport-logged-in')
        : window.route('post.freereport');

    if (!validate()) return;

    loading.value = true;

    const params = {
        ...form.value,
        user: window.currentUser,
        resolution: {
            height: window.innerHeight,
            width: window.innerWidth
        }
    };

    axios.post(route, params)
        .then((response) => {
            displayEmail.value = form.value.email;
            flashRef.value.display('Your request has been sent! Your FREE Special Report will be sent to ' + form.value.email + '.');
            reset();
        })
        .catch((error) => {
            if (error.response?.status === 500) {
                flashRef.value.error('Something went wrong, please try again later');
            } else if (error.response?.data?.errors) {
                for (const field in error.response.data.errors) {
                    errors.value[field] = error.response.data.errors[field][0];
                }
            } else {
                flashRef.value.error('Something went wrong, please try again later');
            }
        })
        .finally(() => {
            loading.value = false;
            grecaptcha.reset();
        });
};

onMounted(() => {
    if (!loggedIn.value) {
        const renderCaptcha = () => {
            if (typeof grecaptcha !== 'undefined') {
                grecaptcha.render('captcha', {
                    sitekey: props.siteKey,
                    callback: updateCaptcha
                });
            } else {
                setTimeout(renderCaptcha, 300);
            }
        };
        renderCaptcha();
    }
});
</script>

<style lang="scss">
#freeReportForm {
    .form-input {
        margin-top: 0.2rem !important;
        margin-bottom: 0.2rem !important;
    }

    .form-label-class {
        font-weight: 600;
        display: inline-block;
    }

    #captcha {
        display: flex;
        justify-content: center;
        transform: scale(0.8);
    }

    #captcha > div {
        margin-left: auto !important;
        margin-right: auto !important;
        width: auto !important;
    }

    @media (max-width: 319px) {
        #captcha {
            transform: scale(0.6);
        }
    }
}
</style>
